<app-modal #modal [wide]="true" (dismissed)="modalDismissed()">
  @if (payment) {
    <h3>Payment</h3>

    <div class="grid gap-4">
      <div class="grid md:grid-cols-2 gap-4">
        <div class="card">
          <div class="card-body">
            <table class="table">
              <tbody>
                @if (payment.payoutType) {
                  <tr>
                    <td>Type</td>
                    <td>
                      @if (isTopUpRefund(payment)) {
                        Top-Up Refund
                      } @else if (payoutTypeMap[payment.payoutType]) {
                        {{ payoutTypeMap[payment.payoutType].title }}
                      } @else {
                        {{ payment.payoutType }}
                      }
                    </td>
                  </tr>
                }
                <!-- @if (payment.origin) {
                  <tr>
                    <td>Origin</td>
                    <td>
                      @if (commissionOriginMap[payment.origin]) {
                        {{ commissionOriginMap[payment.origin].title }}
                      } @else {
                        {{ payment.origin }}
                      }
                    </td>
                  </tr>
                } -->
                @if (payment.transaction?.type) {
                  <tr>
                    <td>Transaction Type</td>
                    <td>
                      @if (
                        creditTransactionTypeMap[payment.transaction!.type!];
                        as transactionType
                      ) {
                        <fa-icon [icon]="transactionType.icon"></fa-icon>
                        {{ transactionType.title }}
                      } @else {
                        {{ payment.transaction!.type }}
                      }
                    </td>
                  </tr>
                }
                @if (direction(); as direction) {
                  <tr>
                    <td>Direction</td>
                    <td [class]="direction.textClass">
                      {{ direction.title }}
                    </td>
                  </tr>
                }
                @if (payment.paymentDate) {
                  <tr>
                    <td>Payment Date</td>
                    <td>
                      {{ payment.paymentDate.timestamp | date: 'medium' }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="grid gap-4">
          @if (payment.source) {
            <div class="card">
              <div class="card-body">
                <div class="card-title">Source</div>

                <table class="table">
                  <tbody>
                    @if (payment.source.type) {
                      <tr>
                        <td>Type</td>
                        <td>
                          @if (typeMap[payment.source.type]; as type) {
                            @if (type.icon) {
                              <fa-icon [icon]="type.icon"></fa-icon>
                            }
                            {{ type.title }}
                          }
                        </td>
                      </tr>
                    }
                    @if (payment.source.lead) {
                      @if (payment.source.lead.firstName) {
                        <tr>
                          <td>First Name</td>
                          <td>
                            {{ payment.source.lead.firstName }}
                          </td>
                        </tr>
                      }
                      @if (payment.source.lead.lastName) {
                        <tr>
                          <td>Last Name</td>
                          <td>
                            {{ payment.source.lead.lastName }}
                          </td>
                        </tr>
                      }
                      @if (payment.source.lead.phone) {
                        <tr>
                          <td>Phone</td>
                          <td>
                            {{ payment.source.lead.phone }}
                          </td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }

          @if (payment.agent) {
            <div class="card">
              <div class="card-body">
                <div class="card-title">Agent</div>

                <table class="table">
                  <tbody>
                    @if (payment.agent.firstName || payment.agent.lastName) {
                      <tr>
                        <td>Name</td>
                        <td>
                          {{ payment.agent.firstName }}
                          {{ payment.agent.lastName }}
                        </td>
                      </tr>
                    }
                    @if (payment.agent.npn) {
                      <tr>
                        <td>NPN</td>
                        <td>{{ payment.agent.npn }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }

          @if (payment.transaction) {
            <div class="card">
              <div class="card-body">
                <div class="card-title">Transaction</div>

                <table class="table">
                  <tbody>
                    <tr>
                      <td>Amount</td>
                      <td
                        class="font-medium"
                        [class]="direction()?.textClass ?? ''">
                        {{ payment.transaction.amount | currency }}
                      </td>
                    </tr>
                    <tr>
                      <td>Account</td>
                      <td>
                        @if (payment.transaction.account?.id) {
                          <app-account-card
                            type="card"
                            [accountId]="payment.transaction.account?.id"
                            [owner]="
                              payment.transaction.account?.owner
                            "></app-account-card>
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>Wallet</td>
                      <td>
                        <app-wallet-kind-badge
                          [account]="
                            payment.transaction.account
                          "></app-wallet-kind-badge>
                      </td>
                    </tr>
                    @if (fundingSource(); as funding) {
                      <tr>
                        <td>Funding Source</td>
                        <td>
                          <div class="flex flex-col gap-2">
                            <span class="flex items-center gap-2">
                              <fa-icon [icon]="funding.icon"></fa-icon>
                              {{ funding.title }}
                            </span>
                            @if (funding.counterpart) {
                              <app-wallet-kind-badge
                                [account]="funding.counterpart"
                                [small]="true"></app-wallet-kind-badge>
                            }
                          </div>
                        </td>
                      </tr>
                    }
                    <tr>
                      <td>Note</td>
                      <td>
                        {{ payment.note }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>

        @if (payment.allowance; as allowance) {
          <div class="card bg-base-100 border border-base-300 md:col-span-2">
            <div class="card-body">
              <div class="card-title">Team Allowance</div>
              <p class="text-sm text-base-content/70">
                Paid from a team allowance granted to the agent on this wallet.
              </p>

              <table class="table">
                <tbody>
                  @if (allowance.totalAllowance !== undefined) {
                    <tr>
                      <td>Allowance</td>
                      <td>{{ allowance.totalAllowance | currency }}</td>
                    </tr>
                  }
                  @if (allowance.remainingAllowance !== undefined) {
                    <tr>
                      <td>Remaining at time of purchase</td>
                      <td>{{ allowance.remainingAllowance | currency }}</td>
                    </tr>
                  }
                  @if (allowance.spentAmount !== undefined) {
                    <tr>
                      <td>Spent at time of purchase</td>
                      <td>{{ allowance.spentAmount | currency }}</td>
                    </tr>
                  }
                  @if (allowancePeriodName(allowance.period); as period) {
                    <tr>
                      <td>Period</td>
                      <td>{{ period }}</td>
                    </tr>
                  }
                  @if (allowance.id) {
                    <tr>
                      <td>Allowance ID</td>
                      <td class="font-mono text-xs">{{ allowance.id }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (payment.accountTransfer) {
          <div
            class="card bg-base-100 border border-base-300 mb-6 md:col-span-2">
            <div class="card-body">
              <div class="card-title">Transfer</div>

              <div class="grid md:grid-cols-3 gap-4 items-center">
                <!-- Source Account After Transfer -->
                <div class="flex flex-col gap-2">
                  <app-account-card
                    type="card"
                    [accountId]="payment.accountTransfer.fromAccount?.id"
                    [owner]="
                      payment.accountTransfer.fromAccount?.owner
                    "></app-account-card>
                  <app-wallet-kind-badge
                    [account]="payment.accountTransfer.fromAccount"
                    [small]="true"></app-wallet-kind-badge>
                </div>

                <!-- Transfer Arrow -->
                <div class="text-center">
                  <div class="flex items-center justify-center">
                    <fa-icon
                      [icon]="faArrowRight"
                      class="text-2xl text-primary"></fa-icon>
                  </div>
                  <div class="text-lg font-bold text-primary mt-2">
                    {{ payment.accountTransfer.amount | currency }}
                  </div>
                </div>

                <!-- Target Account After Transfer -->
                <div class="flex flex-col gap-2">
                  <app-account-card
                    type="card"
                    [accountId]="payment.accountTransfer.toAccount?.id"
                    [owner]="
                      payment.accountTransfer.toAccount?.owner
                    "></app-account-card>
                  <app-wallet-kind-badge
                    [account]="payment.accountTransfer.toAccount"
                    [small]="true"></app-wallet-kind-badge>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <app-loading></app-loading>
  }
</app-modal>
